export const extractText = (data, term) => {
  const text = data.find(o => o.id === term);
  return text?.value;
};
